module.exports = "/_next/static/images/wallet-monotone-73bd184429bb97a143d89fd28155b92c.svg";